export default __webpack_public_path__ + "static/media/nav_game.f2202f7a.svg";